import { GlobalErrorHandlerService, AuthGuard } from '@shared/services';
import type { Routes } from '@angular/router';

// ChannelsPage, SkuActionPage,
import {
    AccountPage, AccountsPage, AccountNewPage, AccountProfilePage, CacheLoginCredsPage, 
    CrmActivitiesPage, CrmContactsPage, CrmProspectsPage, CrmSetupPage, CrmTabsPage, TagAnalysisPage,  
    DashboardPage, DocumentPage, DocumentsPage, ExportPage, ImportPage, LoginPage, 
    OrderPage, OrdersPage, PricePage, PricesPage, RewardFunnelTestsPage, SettingsPage, SkuActionsPage,
    SkuActionPage, SmsFromNumbersPage, SmsSentMessagesPage, TestsPage, TestSmsPage, UsersPage
} from '@backend/pages';
import {
    AddressModalPage, CalendarModalPage, CheckboxModalPage, NotFoundPage,PickupRequestModalPage,
    PopoverMenuPage, RadioModalPage, TicketsModalPage, VariablesModalPage
} from '@shared/pages';

export const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: LoginPage },
    { path: 'account', component: AccountPage, canActivate: [AuthGuard] },
    { path: 'accountNew', component: AccountNewPage, canActivate: [AuthGuard] },
    { path: 'accountProfile', component: AccountProfilePage, canActivate: [AuthGuard] },
    { path: 'account/:uid', component: AccountPage, canActivate: [AuthGuard] },
    // { path: 'managerSettings/users/user/:uid', component: UserPage, canActivate: [AuthGuard] },

    { path: 'accounts', component: AccountsPage, canActivate: [AuthGuard] },
    { path: 'addressModal', component: AddressModalPage, canActivate: [AuthGuard] },
    { path: 'calendarModal', component: CalendarModalPage, canActivate: [AuthGuard] },
    { path: 'cacheLoginCreds', component: CacheLoginCredsPage, canActivate: [AuthGuard] },

    { path: 'crm', component: CrmTabsPage, canActivate: [AuthGuard] },
    { path: 'crm/tabs', component: CrmTabsPage, canActivate: [AuthGuard] },
    { path: 'crm/tabs/tagAnalysis', component: TagAnalysisPage, canActivate: [AuthGuard] },
    { path: 'crm/tabs/activities', component: CrmActivitiesPage, canActivate: [AuthGuard] },
    { path: 'crm/tabs/prospects', component: CrmProspectsPage, canActivate: [AuthGuard] },
    { path: 'crm/tabs/contacts', component: CrmContactsPage, canActivate: [AuthGuard] },
    { path: 'crm/tabs/setup', component: CrmSetupPage, canActivate: [AuthGuard] },

    { path: 'crmActivities', component: CrmActivitiesPage, canActivate: [AuthGuard] },
    { path: 'crmContacts', component: CrmContactsPage, canActivate: [AuthGuard] },
    { path: 'crmProspects', component: CrmProspectsPage, canActivate: [AuthGuard] },
    { path: 'tagAnalysis', component: TagAnalysisPage, canActivate: [AuthGuard] },
    { path: 'crmTabs', component: CrmTabsPage, canActivate: [AuthGuard] },

    { path: 'dashboard', component: DashboardPage, canActivate: [AuthGuard] },
    { path: 'document', component: DocumentPage, canActivate: [AuthGuard] },
    { path: 'documents', component: DocumentsPage, canActivate: [AuthGuard] },
    { path: 'export', component: ExportPage, canActivate: [AuthGuard] },
    { path: 'import', component: ImportPage, canActivate: [AuthGuard] },
    { path: 'order', component: OrderPage, canActivate: [AuthGuard] },
    { path: 'orders', component: OrdersPage, canActivate: [AuthGuard] },
    { path: 'price', component: PricePage, canActivate: [AuthGuard] },
    { path: 'prices', component: PricesPage, canActivate: [AuthGuard] },
    { path: 'settings', component: SettingsPage, canActivate: [AuthGuard] },
    { path: 'skuActions', component: SkuActionsPage, canActivate: [AuthGuard] },
    { path: 'skuAction/:uid', component: SkuActionPage, canActivate: [AuthGuard] },
    { path: 'smsFromNumbers', component: SmsFromNumbersPage, canActivate: [AuthGuard] },
    { path: 'smsSentMessages', component: SmsSentMessagesPage, canActivate: [AuthGuard] },
    { path: 'pickupRequestModal', component: PickupRequestModalPage, canActivate: [AuthGuard] },
    { path: 'popoverMenu', component: PopoverMenuPage, canActivate: [AuthGuard] },
    // { path: 'privacyPolicy', component: PrivacyPolicyPage, canActivate: [AuthGuard] },
    { path: 'radioModal', component: RadioModalPage, canActivate: [AuthGuard] },
    { path: 'tests', component: TestsPage, canActivate: [AuthGuard] },
    { path: 'tests/rewardFunnelTests', component: RewardFunnelTestsPage, canActivate: [AuthGuard] },
    { path: 'testSms', component: TestSmsPage, canActivate: [AuthGuard] },
    { path: 'users', component: UsersPage, canActivate: [AuthGuard] },
    { path: '**', component: NotFoundPage }
];
